import { Codebook } from '../Codebook'

export type MonthDayId = number

export class MonthDay extends Codebook<MonthDayId> {
  static {
    for (let i = 1; i <= 31; ++i) {
      void new MonthDay(i)
    }
  }

  name(): string {
    return `${this.id}.`
  }
}
